import * as z from 'zod'
import { TFunction } from 'i18next'
import { FiscalType } from 'src/api/api.generated'

export function getDocumentCustomerSchema() {
  return z.object({
    id: z.string().min(1),
    fiscalCode: z.string().optional(),
    vatNumber: z.string().optional(),
    countryCode: z.string().optional(),
    municipalityId: z.string().optional(),
    postalCode: z.string().optional(),
    city: z.string().optional(),
    address: z.string().optional(),
    province: z.string().optional(),
    name: z.string().optional(),
    email: z.string().optional(),
    splitPayment: z.boolean(),
    sdiCode: z.string().optional(),
  })
}

const documentCustomerFormSchema = getDocumentCustomerSchema()
export type DocumentCustomerFormSchema = z.infer<typeof documentCustomerFormSchema>

export function getDocumentCustomerIssues(
  path: string, //
  data: DocumentCustomerFormSchema,
  fiscalType: FiscalType | null | undefined,
  t?: TFunction,
): z.IssueData[] {
  const issues: z.IssueData[] = []

  if (fiscalType === FiscalType.INVOICE || fiscalType === FiscalType.RECEIPT) {
    if (fiscalType === FiscalType.INVOICE) {
      if (!data.fiscalCode && !data.vatNumber) {
        issues.push({
          code: z.ZodIssueCode.custom,
          message: t?.('pms.booking.reservation.create_deposit.vat_number_fiscal_code_error'),
          path: [`${path}.vatNumber`],
        })
        issues.push({
          code: z.ZodIssueCode.custom,
          message: t?.('pms.booking.reservation.create_deposit.vat_number_fiscal_code_error'),
          path: [`${path}.fiscalCode`],
        })
      }
      if (!data.countryCode) {
        issues.push({
          code: z.ZodIssueCode.custom,
          message: t?.('validation.required_error'),
          path: [`${path}.countryCode`],
        })
      }

      if (data.countryCode === 'IT' && !data.municipalityId) {
        issues.push({
          code: z.ZodIssueCode.custom,
          message: t?.('validation.required_error'),
          path: [`${path}.municipalityId`],
        })
      }

      if (data.countryCode !== 'IT' && !data.city) {
        issues.push({
          code: z.ZodIssueCode.custom,
          message: t?.('validation.required_error'),
          path: [`${path}.city`],
        })
      }

      if (!data.address) {
        issues.push({
          code: z.ZodIssueCode.custom,
          message: t?.('validation.required_error'),
          path: [`${path}.address`],
        })
      }

      if (!data.name) {
        issues.push({
          code: z.ZodIssueCode.custom,
          message: t?.('validation.required_error'),
          path: [`${path}.name`],
        })
      }
    }
  }

  return issues
}
